const themeSwitch = {
    light: {
      headerBg: '#F7B30C',
      fontColor: 'black',
      bodybg: 'white',
    },
    dark: {
      headerBg: '#3c3c3c',
      fontColor: 'white',
      bodybg: 'black',
    },
  };
  
  export default themeSwitch;